"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ModalView = function ModalView(props) {
  var show = props.show;
  var style = show ? {
    display: 'block',
    opacity: 1,
    marginTop: '10%'
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    id: "myModal",
    className: "modal fade ".concat(show && 'in'),
    style: style,
    role: "dialog"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-dialog"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-content"
  }, props.children))), show && /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-backdrop fade in",
    style: {
      opacity: 0.8
    }
  }));
};

var Header = function Header(props) {
  var handleClose = props.handleClose;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-header"
  }, props.children, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: handleClose,
    className: "close",
    "data-dismiss": "modal"
  }, "\xD7"));
};

var Body = function Body(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-body"
  }, props.children);
};

var Footer = function Footer(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    "class": "modal-footer"
  }, props.children);
};

ModalView.Header = Header;
ModalView.Body = Body;
ModalView.Footer = Footer;
var _default = ModalView;
exports["default"] = _default;